import { DecisionReason, InAppMessage, List } from "../../../../model/model"
import { EvaluatorContext, EvaluatorEvaluation } from "../../../evalautor/Evaluator"
import { InAppMessageEvaluatorEvaluation } from "../InAppMessageEvaluatorEvaluation"
import { InAppMessageLayoutEvaluation } from "../layout/InAppMessageLayoutEvaluation"
import { InAppMessageEligibilityRequest } from "./InAppMessageEligibilityRequest"

export class InAppMessageEligibilityEvaluation implements InAppMessageEvaluatorEvaluation {
  constructor(
    public readonly reason: string,
    public readonly targetEvaluations: List<EvaluatorEvaluation>,
    public readonly inAppMessage: InAppMessage,
    public readonly isEligible: boolean,
    public readonly layoutEvaluation: InAppMessageLayoutEvaluation | null
  ) {}

  static eligible(
    request: InAppMessageEligibilityRequest,
    context: EvaluatorContext,
    reason: DecisionReason
  ): InAppMessageEligibilityEvaluation {
    return InAppMessageEligibilityEvaluation.of(request, context, reason, true)
  }

  static ineligible(
    request: InAppMessageEligibilityRequest,
    context: EvaluatorContext,
    reason: DecisionReason
  ): InAppMessageEligibilityEvaluation {
    return InAppMessageEligibilityEvaluation.of(request, context, reason, false)
  }

  static of(
    request: InAppMessageEligibilityRequest,
    context: EvaluatorContext,
    reason: DecisionReason,
    isEligible: boolean
  ): InAppMessageEligibilityEvaluation {
    return new InAppMessageEligibilityEvaluation(
      String(reason),
      context.targetEvaluations,
      request.inAppMessage,
      isEligible,
      context.get(InAppMessageLayoutEvaluation)
    )
  }
}
